import './style.scss';
import React from 'react';

interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  children: React.ReactNode;
}

export const Radio = ({ children, ...props }: RadioProps) => {
  return (
    <label className="radio-label">
      <input className="radio-input" type="radio" {...props} />
      {children}
    </label>
  );
};
